import { useEffect, useState } from "react"
import { subscribe, useSnapshot } from "valtio"
import { AgAddress, AgUnlocde } from "../components/ag-address/ag-address"
import { AgInput, AgUnloc } from "../components/AgComponents"
import AgLabel from "../components/AgLabel"
import NewAddress from "../components/new-address"
import { useGlobalState } from "../GlobalState"
import Taskapi from "../mytasks/tasks-api"
import BookingsApi from "../state/bookings-api"
import { configStore, contractsStore, bookingsStore } from "../state/CommonState"
import Utils from "../util/Utils"
import { enquiryStore } from "./enquiry-data"
import NewAddress1 from "../components/new-address1"
import NewAddress2 from "../components/new-address2"


export default function TempRoute(props) {
    useSnapshot(contractsStore)
    useSnapshot(enquiryStore)
    const { currentMenu } = useGlobalState();
    const rec = enquiryStore.current.enqRoute

    useEffect(() => {
        let unsubscribe = subscribe(enquiryStore.current.enqRoute, () => {
            if (contractsStore.current) {
                contractsStore.current.customerReferenceNum = rec.customerReferenceNum
            }
            if (rec.origin.length != 0 || rec.destination.length != 0 || rec.cargoReadinessDate.length != 0 || rec.customerReferenceNum.length != 0) {
                configStore.showEnquiries = false
            }
            //console.log('Routes changed=', rec.origin, rec.destination)
            if (Utils.isUnloc(rec.origin) && Utils.isUnloc(rec.destination))
                configStore.homescreenCurrentShipmentScope = 'Port-to-Port'
            else if (Utils.isUnloc(rec.origin) && !Utils.isUnloc(rec.destination))
                configStore.homescreenCurrentShipmentScope = 'Port-to-Door'
            else if (!Utils.isUnloc(rec.origin) && Utils.isUnloc(rec.destination))
                configStore.homescreenCurrentShipmentScope = 'Door-to-Port'
            else
                configStore.homescreenCurrentShipmentScope = 'Door-to-Door'
            console.log('\n\n**** Inside the setscope use effect=', configStore.homescreenCurrentShipmentScope, rec.origin)
            enquiryStore.current.shipmentScope = configStore.homescreenCurrentShipmentScope
            if (configStore.scheduleOrCarrierform == 'carrierform') {
                bookingsStore.current.contract = contractsStore.current
            }
        })
        return unsubscribe
    }, [enquiryStore.current.enqRoute])


    if (!contractsStore.current) return <></>
    //console.log('FROM ENQUIRY STORE=', enquiryStore.current.enqRoute)


    let disabled = {}


    if (props.viewonly) disabled = { disabled: 1 }

    let otype = enquiryStore.current.originType
    if (!otype) otype = 'Port'
    let dtype = enquiryStore.current.destinationType
    if (!dtype) dtype = 'Port'

    configStore.homescreenCurrentShipmentScope = `${otype}-to-${dtype}`
    return (
        <div style={{ boxShadow: '5px 5px #dddddd', border: '1px solid lightgrey' }}>
            <header className="card-header">
                <p className="card-header-title">
                    <span className="icon is-small mr-2">
                        <i className="fas fa-road"></i>
                    </span>
                    Route
                </p>
            </header>
            <div className="card-content">
                <div className="content">
                    <div className="columns">
                        <div className="column is-12">
                            <NewAddress2 {...disabled} label='Origin' record={rec} name='origin' />
                        </div>
                    </div>
                    <div className="columns">
                        <div className="column is-12">
                            <NewAddress2 {...disabled} label='Destination' record={rec} name='destination' />
                        </div>
                    </div>
                    <div className="columns">
                        <div className="column is-6">
                            <AgInput {...disabled} label='Cargo Readiness Date' record={rec}
                                name='cargoReadinessDate' type='date' />
                        </div>
                        <div className="column is-6">
                            <AgInput label='Cust Ref #' record={rec}
                                name='customerReferenceNum' />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}